var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"name":"address-level-1","items":_vm.items,"item-text":"state","item-value":"abbr","value":_vm.value},on:{"input":function (newVal) { return _vm.$emit('input', newVal); }}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }